import React, { useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";
import { Check, Loader2, Pencil, Sparkles } from "lucide-react";

/** Lieferant «automatisch aus Beleg angelegt»: Badge + Name prüfen/korrigieren + bestätigen. */
export function AutoSupplierConfirm({ companyId, supplier, onConfirmed }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(supplier.name || "");
  const [busy, setBusy] = useState(false);
  const id = supplier._id || supplier.id;

  const confirm = async () => {
    if (!name.trim()) return;
    setBusy(true);
    try {
      const r = await apiClient.put(`/companies/${companyId}/contacts/${id}/confirm-auto`, { name: name.trim() });
      toast.success(`Lieferant bestätigt: ${r.data.name}`);
      onConfirmed?.(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Bestätigung fehlgeschlagen"); } finally { setBusy(false); }
  };

  const title = `Automatisch aus Beleg angelegt${supplier.auto_created_at ? ` am ${new Date(supplier.auto_created_at).toLocaleDateString("de-CH")}` : ""}${supplier.auto_created_confidence ? ` · ${Math.round(supplier.auto_created_confidence * 100)} % sicher` : ""} – Name bitte prüfen`;

  return (
    <div className="mt-1 flex flex-wrap items-center gap-1.5" data-testid={`supplier-auto-confirm-${id}`}>
      <span title={title} data-testid={`supplier-auto-created-badge-${id}`}
        className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] text-amber-700">
        <Sparkles className="h-3 w-3" /> automatisch aus Beleg angelegt
      </span>
      {editing ? (
        <input
          className="w-56 rounded border border-amber-400 bg-white px-1.5 py-0.5 text-xs text-slate-800"
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") confirm(); if (e.key === "Escape") setEditing(false); }}
          data-testid={`supplier-auto-name-input-${id}`}
        />
      ) : (
        <button type="button" onClick={() => setEditing(true)} title="Namen korrigieren"
          className="inline-flex items-center gap-1 rounded border border-slate-300 bg-white px-1.5 py-0.5 text-[11px] text-slate-600 hover:bg-slate-50"
          data-testid={`supplier-auto-edit-${id}`}>
          <Pencil className="h-3 w-3" /> Name ändern
        </button>
      )}
      <button type="button" onClick={confirm} disabled={busy || !name.trim()}
        className="inline-flex items-center gap-1 rounded bg-emerald-600 px-2 py-0.5 text-[11px] font-medium text-white hover:bg-emerald-700 disabled:opacity-50"
        data-testid={`supplier-auto-confirm-btn-${id}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Check className="h-3 w-3" />} {editing && name.trim() !== (supplier.name || "").trim() ? "Korrigieren & bestätigen" : "Name bestätigen"}
      </button>
    </div>
  );
}
